import { ButtonType, ButtonWidget, TabStyles } from '@tableau/widgets';
import * as React from 'react';
import { style } from 'typestyle';

import { Messages } from '../../../../../codegen/Localize';
import { openClearSavedRevisionsDialog } from './ClearSavedRevisionsDialog';
import { RevisionHistorySectionProps } from './RevisionHistorySection';

const paddingTop = style({
  marginTop: TabStyles.Spacing.MediumSpace
});

export function RevisionHistoryClearButton(props: RevisionHistorySectionProps) {
  const handleClick = React.useCallback(() => openClearSavedRevisionsDialog(), []);
  return (
    !props.hideRevisionHistoryLimitWarning
    && <ButtonWidget buttonType={ButtonType.Outline}
                     className={paddingTop}
                     onClick={handleClick}
                     testId={'clear-saved-revisions'}
                     type={'button'}>
      {Messages.clearSavedRevisions_action()}
    </ButtonWidget>
  );
}
